import React from 'react';
import { PhoneIcon, BellRingIcon } from 'lucide-react';
import { AnyContact } from '../types';
interface ContactCardProps {
  contact: AnyContact;
  isActive: boolean;
  onClick: (contact: AnyContact) => void;
  onCall: (contact: AnyContact) => void;
  disabled?: boolean;
}
export function ContactCard({
  contact,
  isActive,
  onClick,
  onCall,
  disabled = false
}: ContactCardProps) {
  const today = new Date().toISOString().split('T')[0];
  const isFollowUpToday = contact.scheduledFollowUp === today;
  const latestNote = contact.history.find(h => h.type === 'note') || contact.history[0];
  const getBadgeColor = () => {
    if (contact.type === 'lead') return 'bg-cyan-400 shadow-[0_0_8px_rgba(34,211,238,0.4)]';
    if (contact.type === 'loan') return 'bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.4)]';
    return 'bg-olympian-gold shadow-[0_0_8px_rgba(212,168,67,0.4)]';
  };
  const borderStyle = isActive ? 'bg-olympian-gold/10 border-olympian-gold/50 shadow-[inset_4px_0_0_rgba(212,168,67,1)]' : isFollowUpToday ? 'bg-cyan-500/5 border-cyan-500/30 shadow-[inset_4px_0_0_rgba(6,182,212,0.8)] hover:bg-cyan-500/10' : 'bg-olympian-surface/50 border-olympian-border hover:bg-olympian-surface hover:border-olympian-textMuted/30';
  return <div className={`w-full text-left px-4 py-3 rounded-lg border transition-all duration-200 group relative flex items-center gap-4 ${borderStyle} ${disabled ? 'opacity-50 pointer-events-none grayscale-[50%]' : 'cursor-pointer'}`} onClick={() => !disabled && onClick(contact)} data-id="element-42">
      {/* Lane Dot */}
      <div className={`w-2 h-2 rounded-full shrink-0 ${getBadgeColor()}`} data-id="element-43" />

      {/* Name & Phone */}
      <div className="w-48 shrink-0" data-id="element-44">
        <div className="font-bold text-theme text-sm truncate flex items-center gap-2" data-id="element-45">
          {contact.name}
          {isFollowUpToday && <span className="bg-cyan-500/15 text-cyan-400 px-1.5 py-0.5 rounded text-[9px] uppercase tracking-wider flex items-center gap-1" data-id="element-46">
              <BellRingIcon className="w-2.5 h-2.5" data-id="element-47" /> Today
            </span>}
        </div>
        <div className="text-xs text-olympian-textMuted font-mono mt-0.5" data-id="element-48">
          {contact.phone}
        </div>
      </div>

      {/* Note */}
      <div className="flex-1 min-w-0" data-id="element-49">
        <div className="text-xs text-olympian-textMuted italic truncate" title={latestNote?.description} data-id="element-50">
          {latestNote ? `"${latestNote.description}"` : 'No notes yet.'}
        </div>
      </div>

      {/* Action */}
      <div className="shrink-0 pl-2" data-id="element-51">
        <button onClick={e => {
        e.stopPropagation();
        onCall(contact);
      }} disabled={disabled} className="bg-olympian-gold/10 text-olympian-gold hover:bg-olympian-gold hover:text-olympian-navy p-2 rounded-md transition-colors disabled:opacity-50" title="Call" aria-label={`Call ${contact.name}`} data-id="element-52">
          <PhoneIcon className="w-4 h-4" data-id="element-53" />
        </button>
      </div>
    </div>;
}